(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[698],{

/***/ 4931:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/careers",
      function () {
        return __webpack_require__(5464);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ careers; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/layouts/default/index.tsx + 7 modules
var layouts_default = __webpack_require__(6493);
// EXTERNAL MODULE: ./src/helpers/DATA.tsx + 9 modules
var DATA = __webpack_require__(8362);
;// CONCATENATED MODULE: ./public/images/career-image.jpg
/* harmony default export */ var career_image = ({"src":"/_next/static/media/career-image.8bce1102.jpg","height":627,"width":1024,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAcEAACAwEAAwAAAAAAAAAAAAABAgAEEQMFIVH/xAAUAQEAAAAAAAAAAAAAAAAAAAAB/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AoefnLle2r8WAWzzVWRiSFzToG4D7+REQL//Z","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/pages/careers/index.tsx
// ** Next imports


// ** File imports


// ** Image imports

const Pcol = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: "col-grey1",
        children: props.children
    });
};
const Hcol = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
        className: "col-black",
        children: props.children
    });
};
const Careers = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts_default/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_default/* SEOHead */.R, {
                title: "Carbon Neutral"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-silver1 pad-top-40 pad-bot-40",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sec-head",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "no-margin text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "Careers"
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "pad-top-60 pad-bot-60",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-6 col-lg-6 col-sm-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "block-element m-t-20",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "custom-image2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: career_image,
                                            className: "img-fluid",
                                            placeholder: "blur",
                                            alt: "Career image"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-6 col-lg-6 col-sm-6 col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "faq-textual",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hcol, {
                                            children: "Working at EIN:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Pcol, {
                                            children: "We are proponents of balance and believe that work can be both fun and productive. Many of our positions are remote positions, allowing you to work from home or your favorite coffee shop."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hcol, {
                                            children: "Open Positions:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Pcol, {
                                            children: "No open positions at this time."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Pcol, {
                                            children: [
                                                "We’re always growing so feel free to email your resume or career inquiry to us anytime at",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "mailto:".concat(DATA/* CONTACT_INFO.email */.dZ.email),
                                                    children: DATA/* CONTACT_INFO.email */.dZ.email
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
/* harmony default export */ var careers = (Careers);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [976,948,910,493,774,888,179], function() { return __webpack_exec__(4931); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);